import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { auth } from '../config/firebaseConfig';
import { signOut } from 'firebase/auth';
import {
    ArrowLeftOnRectangleIcon,
    Bars3Icon,
    XMarkIcon,
    HomeIcon,
    UsersIcon,
    CalendarDaysIcon,
    UserGroupIcon,
    EnvelopeIcon,
    ShoppingCartIcon,
    ClipboardDocumentListIcon,
    DocumentTextIcon // Yeni Eklendi
} from '@heroicons/react/24/outline';
import { Dropdown } from 'react-bootstrap';

const AdminHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = useAuth();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/admin/login');
        } catch (error) {
            console.error("Failed to log out:", error);
        }
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const firstName = userData?.displayName?.split(' ')[0] || '';

    // allowedRoles yerine requiredModule anahtarları atandı
    const mainLinks = [
        { to: "/admin", icon: <HomeIcon />, text: "Dashboard", requiredModule: null }, // Dashboard her zaman açık
        { to: "/admin/manage-tasks", icon: <ClipboardDocumentListIcon />, text: "Task Board", requiredModule: "manage-tasks" },
        { to: "/admin/manage-users", icon: <UsersIcon />, text: "Users", requiredModule: "manage-users" },
    ];

    const manageLinks = [
        { to: "/admin/manage-events", icon: <CalendarDaysIcon />, text: "Events", requiredModule: "manage-events" },
        { to: "/admin/manage-professionals", icon: <UserGroupIcon />, text: "Professionals", requiredModule: "manage-professionals" },
        { to: "/admin/manage-campaigns", icon: <EnvelopeIcon />, text: "Campaigns", requiredModule: "manage-campaigns" },
        { to: "/admin/manage-orders", icon: <ShoppingCartIcon />, text: "Orders", requiredModule: "manage-orders" },
        { to: "/admin/manage-landing-pages", icon: <DocumentTextIcon />, text: "Landing Pages", requiredModule: "manage-book-pages" } // Yeni Eklendi
    ];

    // Yetki Kontrol Fonksiyonu
    const hasAccess = (requiredModule) => {
        if (!userData) return false;
        if (userData.role === 'admin') return true;
        if (!requiredModule) return true; // Modül sınırı yoksa göster
        return userData.permissions && userData.permissions[requiredModule];
    };

    const visibleMainLinks = mainLinks.filter(link => hasAccess(link.requiredModule));
    const visibleManageLinks = manageLinks.filter(link => hasAccess(link.requiredModule));

    return (
        <header className="admin-header d-flex align-items-center justify-content-between p-3 bg-white shadow-sm">
            <div className="header-logo fw-bold fs-5" style={{ color: '#2c3e50' }}>
                LITTLE HIBBA <span style={{ color: '#6c5ce7' }}>ADMIN</span>
            </div>

            <nav className={`admin-nav d-flex align-items-center gap-3 ${isMenuOpen ? 'active' : 'd-none d-md-flex'}`}>
                {visibleMainLinks.map((link) => (
                    <NavLink to={link.to} key={link.text} end={link.to === "/admin"} className={({ isActive }) => `text-decoration-none d-flex align-items-center gap-1 px-2 py-1 rounded ${isActive ? 'text-primary fw-bold bg-light' : 'text-secondary'}`}>
                        <span style={{ width: '20px' }}>{link.icon}</span>
                        <span>{link.text}</span>
                    </NavLink>
                ))}

                {visibleManageLinks.length > 0 && (
                    <Dropdown>
                        <Dropdown.Toggle variant="light" className="text-secondary border-0 d-flex align-items-center gap-1 shadow-none bg-transparent px-2 py-1">
                            <span style={{ width: '20px' }}><Bars3Icon /></span>
                            <span>More</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow-sm border-0 mt-2 rounded-3">
                            {visibleManageLinks.map((link) => (
                                <Dropdown.Item as={NavLink} to={link.to} key={link.text} className="d-flex align-items-center gap-2 py-2">
                                    <span style={{ width: '18px' }} className="text-muted">{link.icon}</span>
                                    {link.text}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </nav>

            <div className="header-actions d-flex align-items-center gap-3">
                {firstName && <span className="text-muted d-none d-sm-block small">Hi, {firstName}</span>}
                <button onClick={handleLogout} className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1 rounded-pill px-3">
                    <ArrowLeftOnRectangleIcon style={{ width: '16px' }} />
                    <span className="d-none d-sm-inline">Logout</span>
                </button>
                <button className="btn btn-light d-md-none border-0" onClick={toggleMenu}>
                    {isMenuOpen ? <XMarkIcon style={{ width: '24px' }} /> : <Bars3Icon style={{ width: '24px' }} />}
                </button>
            </div>
        </header>
    );
};

export default AdminHeader;